import axios from 'axios'
const prefix = `https://m.xinli001.com/`
const yiappPrefix = `https://yiapp.xinli001.com/`

export const getUser = token =>
  axios.get(`${prefix}ajax/get-user-header${token ? '?token=' + token : ''}`)

// 发送短信验证码
export const checkValidateAliyun = data =>
  axios.post(`${prefix}ajax/check-validate-aliyun`, data)

// 移动端登陆
export const mobileLogin = params =>
  axios.get(`${prefix}ajax/create-or-bind`, { params })

// 移动端退出
export const mobileLogout = () => axios.get(`${prefix}account/logout`)

// token 写 cookie - 一般用于微信登录后token同步
export const setCookieWithToken = token =>
  axios.get(`${prefix}get-certification-cookie.json?token=${token}`)

// 新人福利页面的登录
export const mobileLoginNew = params =>
  axios.get(`${prefix}consult_activity/popularize/create-or-bind`, { params })

// 后台json配置
export const getConfigureByCode = params =>
  axios.get(`${yiappPrefix}commonConfigure/getConfigureByCode`, { params })
